import React from "react";
import UserDetailsHeader from "../../../UserDetailsHeader";
import { Typography } from "@mui/material";
import videothumbnailIcon from "../../../../../assets/images/HowtoTestVideoThumbnail.svg";
import "../../tug/howToTest/howToTest.scss";
import prerequisitesImg from "../../../../../assets/images/HowToTest/ROM/prerequisites.png";
import setupImg from "../../../../../assets/images/HowToTest/ROM/leftFlexionSetup.png";
import performTestImg from "../../../../../assets/images/HowToTest/ROM/leftFlexionPerformTest.png";
import { getParams } from "../../../../../utlis/helpers";
import { romplaylistItem } from "../../../../../utlis/constants";
import { pageLocale } from "../../../../../utlis/locale";
import uploadImg from "../../../../../assets/images/HowToTest/TugFront/upload.png";
import uploadForJP from "../../../../../assets/images/HowToTest/TugFront/uploadForJP.png";
const HowtoTestLeftFlexion = () => {
  const { locale } = getParams();
  const videoPlayHandler = (link) => {
    window.open(link, "_blank");
  };
  const { upload1, upload2 } = pageLocale("tugFront");
  const {
    armless_chair_desc,
    phone_stand_desc,
    support_desc,
    left_knee_flexion,
    setup1,
    setup2,
    leftsetup3,
    perform1,
    LFperform2,
    perform3,
    perform4,
    setupnewAdd,
  } = pageLocale("romHowToTest");
  const {
    how_to,
    playlist,
    armless_chair,
    phone_stand,
    rom_no_support_person,
    step_guide,
    step_one,
    step_two,
    step_three,
    step_four,
    disable_wide,
    disable_wide_desc,
  } = pageLocale("common");

  const prerequisitesStepsItem = [
    {
      title: armless_chair,
      description: armless_chair_desc,
    },
    {
      title: phone_stand,
      description: phone_stand_desc,
    },
    {
      title: rom_no_support_person,
      description: support_desc,
    },
    {
      title: disable_wide,
      description: disable_wide_desc,
    },
  ];
  return (
    <>
      <UserDetailsHeader>
        <div className="how-to-test-main-wrapper">
          <Typography className="title">
            {left_knee_flexion}: {how_to}
          </Typography>
          <div className="test-instruction-wrapper">
            <Typography className="test-instruction-title">
              {playlist}
            </Typography>
            {romplaylistItem?.map((item, index) => {
              return (
                <div
                  className="video-playlist"
                  key={index}
                  onClick={() =>
                    videoPlayHandler(locale === "en" ? item.urlEN : item.urlJP)
                  }
                >
                  <div>
                    <img src={videothumbnailIcon} alt="thumbnail" />
                  </div>
                  <div>
                    <Typography>{item.title}</Typography>
                  </div>
                </div>
              );
            })}
            <Typography className="test-instruction-title">
              {step_guide}
            </Typography>
            <div className="steps-one">
              <Typography className="test-instruction-title">
                1. {step_one}
              </Typography>
              <img
                src={prerequisitesImg}
                alt="prerequisites"
                className="img one"
              />
              {prerequisitesStepsItem?.map((item, index) => {
                return (
                  <div className="prerequisites-step" key={index}>
                    <Typography className="step-title">{item.title}</Typography>
                    <Typography className="description">
                      {item.description}
                    </Typography>
                  </div>
                );
              })}
              <div className="test-step-divider"></div>
            </div>
            <div className="step-two">
              <Typography className="test-instruction-title">
                2. {step_two}
              </Typography>
              <img src={setupImg} alt="steup" className="img" />

              <ul className="list-instruction">
                <li dangerouslySetInnerHTML={{ __html: setup1 }}></li>
                <li dangerouslySetInnerHTML={{ __html: setupnewAdd }}></li>
                <li dangerouslySetInnerHTML={{ __html: setup2 }}></li>
                <li dangerouslySetInnerHTML={{ __html: leftsetup3 }}></li>
              </ul>
              <div className="test-step-divider"></div>
            </div>
            <div className="step-three">
              <Typography className="test-instruction-title">
                3. {step_three}
              </Typography>
              <img src={performTestImg} alt="perform-test" className="img" />
              <ul className="list-instruction">
                <li>{perform1}</li>
                <li dangerouslySetInnerHTML={{ __html: LFperform2 }}></li>
                <li dangerouslySetInnerHTML={{ __html: perform3 }}></li>
                <li>{perform4}</li>
              </ul>
            </div>
            <div className="step-four">
              <Typography className="test-instruction-title">
                4. {step_four}
              </Typography>
              {locale === "en" ? (
                <img src={uploadImg} alt="steup" className="img" />
              ) : (
                <img src={uploadForJP} alt="steup" className="img" />
              )}
              <ul className="list-instruction">
                <li dangerouslySetInnerHTML={{ __html: upload1 }}></li>
                <li dangerouslySetInnerHTML={{ __html: upload2 }}></li>
              </ul>
            </div>
          </div>
        </div>
      </UserDetailsHeader>
    </>
  );
};

export default HowtoTestLeftFlexion;
